/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TeamleaderSubjectFromJSON, TeamleaderSubjectToJSON, } from './TeamleaderSubject.js';
/**
 * Check if a given object implements the SubscriptionInvoicee interface.
 */
export function instanceOfSubscriptionInvoicee(value) {
    if (!('customer' in value) || value['customer'] === undefined)
        return false;
    return true;
}
export function SubscriptionInvoiceeFromJSON(json) {
    return SubscriptionInvoiceeFromJSONTyped(json, false);
}
export function SubscriptionInvoiceeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'customer': TeamleaderSubjectFromJSON(json['customer']),
    };
}
export function SubscriptionInvoiceeToJSON(json) {
    return SubscriptionInvoiceeToJSONTyped(json, false);
}
export function SubscriptionInvoiceeToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'customer': TeamleaderSubjectToJSON(value['customer']),
    };
}
